// extracted by mini-css-extract-plugin
export default {"comment":"ReporterDataDisplay_comment__-SnMF","notifierEmail":"ReporterDataDisplay_notifierEmail__gHlK1"};